import { useEffect } from "react";
import { useParams, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isValidLang } from "@/lib/language";

export const LangLayout = () => {
    const { lang } = useParams();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (isValidLang(lang) && i18n.resolvedLanguage !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return <Outlet />;
};
